import FormField from "@components/FormField";
import HeadlessRadioGroup from "@components/RadioButtonGroup";
import { useField } from "formik";
import { forwardRef } from "react";

function FormikRadioGroup({ label, error, options, className, ...props }, ref) {
  const [field, , helpers] = useField(props.name);

  // console.log("FormikRadioGroup name:", props.name, "value:", field.value);

  return (
    <FormField label={label} id={props.name} errorMsg={error}>
      <HeadlessRadioGroup
        name={props.name}
        value={field.value || null}
        className={className}
        onChangeHandler={(value) => {
          helpers.setValue(value);
        }}
        errorMsg={error}
        label={label}
        options={options}
        ref={ref}
      />
    </FormField>
  );
}

export default forwardRef(FormikRadioGroup);
